// src/pages/docs/game/grp.jsx
import { Typography, Box, Link, Button } from '@mui/material';
import DocsLayout from 'layout/DocsLayout';
import commandList from 'data/commands';
import { useLocation } from 'react-router-dom';
import { getAdjacentCommands } from 'components/getAdjacentCommands';

const GrpCommand = () => {
  const location = useLocation();
  const command = commandList.find((cmd) => cmd.path === location.pathname);
  const { prev, next } = getAdjacentCommands(location.pathname);

  return (
    <DocsLayout>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 4, flexWrap: 'wrap', maxWidth: 800 }}>
        {/* 왼쪽 텍스트 영역 */}
        <Box sx={{ flex: 1, minWidth: 260 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            /그래프, ?그래프
          </Typography>
          <Typography variant="body1" sx={{ mt: -2, mb: 3 }}>
          {command?.description ?? '설명이 없습니다.'}
          </Typography>
          <Typography variant="h6">
            {"사용법: /그래프 <코인, 하프, 올인>,"}<br />{"?그래프 <코인, 하프, 올인>"}<br />{"<>는 필수사항 입니다."}
          </Typography>
          <Typography variant="h6">
            {"동일명령어: ?그래프, ?ㄱㄹㅍ"}
          </Typography>
          <Typography variant="body1" sx={{ mt: 3}}>
          {"예시: /그래프 5000, /ㄱㄹㅍ ㅎㅍ, ?ㄱㄹㅍ ㅇㅇ"}<br />승리시 배팅금액의 0.7~30배를 흭득합니다.
          </Typography>
          <Typography variant="h6"sx={{ mt: 3}}>
          {"그래프 명령어의 확률입니다"}
          </Typography>
          <Typography variant="body1">
          최저배수: 0.7배<br />최대배수: 30배<br />0.7~1.3배가 나올 확률: 18%<br />1.4~2.1배가 나올 확률: 25%<br />2.2~3.5배가 나올 확률: 20%<br />3.6~4.2배가 나올 확률: 17%<br />4.3~30배가 나올 확률: 10%<br />(예시) 0.7, 0.8, 0.9, 1.0, 1.1, 1.2, 1.3이 나올확률은 동일하며 모두 더하면 18%가 됩니다.
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <Link
                href="https://i.imgur.com/e5Adcqs.png"
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: '#5ec8f2' }}
            >
                chat gpt의 추천은 3.6배가 기댓값이 가장 높은 배수라고 합니다.
            </Link>
            </Typography>
          
        </Box>

        {/* 오른쪽 이미지 + 버튼 묶음 */}
        <Box sx={{ 
          display: 'flex',
          flexDirection: 'column',
          alignItems: {xs:'center', md:'flex-start'},
          gap: 2,
          textAlign: { xs: 'center', md: 'left' },
          width: {xs:'100%',md:'auto'},
          maxWidth: {xs:'100%',md:'auto'},
        }}>
          {/* 이미지 */}
          <Box
            component="img"
            src="/commands/grp.webp"
            alt="설명 이미지"
            sx={{
              width: '100%',
              maxWidth: 400,
              borderRadius: 2,
              flexShrink: 0,
              mx: 'auto',
            }}
          />

          {/* 버튼들 */}
          {/* 바깥쪽 박스: 가운데 정렬용 (block + auto) */}
          <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'center' }, gap: 5, width: '100%', mt: 1 }}>
            {prev && (
              <Button href={prev.path} variant="outlined" sx={{ mr:{xs:0},height: 36, width: 118 }}>
                ← {prev.name}
              </Button>
            )}
            {next && (
              <Button href={next.path} variant="outlined" sx={{ height: 36, width: 118 }}>
                {next.name} →
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </DocsLayout>
  );
};

export default GrpCommand;
